import type {ReferralSetting, GenericError} from 'src/types/referral-v2';
import type {ReferralSettingsActions} from 'src/action-creators/referral-v2/referral-settings';
import {
  REFERRAL_SETTINGS_LOADING,
  REFERRAL_SETTINGS,
  REFERRAL_SETTINGS_ERROR,
  UPDATE_PAYOUT_RULE,
  UPDATE_ONE_TIME_SETTINGS,
} from 'src/action-creators/referral-v2/referral-settings';


export const ReferralCurrentState = {
  IDLE: 'idle',
  FETCHING_REFERRAL_SETTINGS: 'fetchingReferralSettings',
} as const;

export type ReferralSettingsState = {
  current_state: string;
  referral_settings: ReferralSetting | null | undefined;
  referral_settings_error: GenericError | null | undefined;
};

const referralSettingInitialState = {
  current_state: '',
  referral_settings: null,
  referral_settings_error: null,
} as const;

export default (
  state: ReferralSettingsState = referralSettingInitialState,
  action: ReferralSettingsActions,
): ReferralSettingsState => {
  switch (action.type) {
    case REFERRAL_SETTINGS: {
      return {
        ...state,
        referral_settings: action.payload,
        current_state: ReferralCurrentState.IDLE,
      };
    }
    case UPDATE_PAYOUT_RULE:
      const referralSettings: ReferralSetting = {
        ...state.referral_settings,
        // @ts-expect-error - TS2322 - Type '{ payout_rule: PayoutRuleData | null | undefined; reward_for_existing_referral?: boolean; duplicate_profile_check_method?: string | undefined; should_pay_for_different_role?: boolean | undefined; timesheet_log_type?: string | undefined; }' is not assignable to type 'ReferralOneTimeSetting'.
        one_time_settings: {
          ...state.referral_settings?.one_time_settings,
          payout_rule: action.payload,
        },
      };
      return {
        ...state,
        referral_settings: referralSettings,
      };
    case UPDATE_ONE_TIME_SETTINGS:
      return {
        ...state,
        // @ts-expect-error - TS2322 - Type '{ one_time_settings: ReferralOneTimeSetting; notifications?: ReferralNotification | undefined; other_settings?: ReferralOtherSetting | undefined; bonus_and_payout_settings?: ReferralBonusAndPayoutSettings | undefined; }' is not assignable to type 'ReferralSetting'.
        referral_settings: {
          ...state.referral_settings,
          one_time_settings: action.payload,
        },
      };
    case REFERRAL_SETTINGS_LOADING:
      return {
        ...state,
        current_state: ReferralCurrentState.FETCHING_REFERRAL_SETTINGS,
      };

    case REFERRAL_SETTINGS_ERROR:
      return {
        ...state,
        referral_settings_error: action.payload,
        current_state: ReferralCurrentState.IDLE,
      };
    default:
      return state;
  }
};
